export class Login {
    constructor(
        public name: string,
        public pass: string,
    ){}

}